import React, { useContext } from 'react';
import BarChart from 'components/@common/Charts/BarChart';
import { PrintViewContext } from '../../../../providers/PrintViewProvider';

interface ScheduledActivityChartProps {
  assessmentWpmSeries: number[];
  assessmentAccuracySeries: number[];
  labels: string[];
  loading?: boolean;
  onClick?: (index: number) => void;
}

const ScheduledActivityChart: React.FC<ScheduledActivityChartProps> = ({
  assessmentWpmSeries,
  assessmentAccuracySeries,
  labels,
  onClick
}) => {
  const { fullChartWidth } = useContext(PrintViewContext);

  return (
    <BarChart
      height={250}
      width={fullChartWidth}
      onClick={onClick}
      series={[
        {
          name: 'Average Speed (WPM)',
          data: assessmentWpmSeries
        },
        {
          name: 'Average Accuracy (%)',
          data: assessmentAccuracySeries
        }
      ]}
      options={{
        colors: ['#4AE2A7', '#A6C1E4'],
        yaxis: [
          {
            decimalsInFloat: 0,
            title: {
              offsetX: -2,
              text: 'Average Speed (WPM)',
              style: {
                color: '#373D3F',
                fontSize: '12px',
                fontWeight: 700,
                fontFamily: 'futura-pt'
              }
            }
          },
          {
            opposite: true,
            min: 0,
            max: 100,
            tickAmount: 4,
            decimalsInFloat: 0,
            title: {
              offsetX: 2,
              text: 'Average Accuracy (%)',
              style: {
                color: '#373D3F',
                fontSize: '12px',
                fontWeight: 700,
                fontFamily: 'futura-pt'
              }
            }
          }
        ],
        xaxis: {
          categories: labels,
          labels: {
            offsetY: -4,
            style: {
              colors: '#373D3F',
              fontSize: '10px',
              fontFamily: 'futura-pt'
            }
          },
          axisTicks: { show: false }
        },
        legend: {
          offsetY: 2,
          horizontalAlign: 'left'
        },
        dataLabels: { enabled: false }
      }}
    />
  );
};

export default React.memo(ScheduledActivityChart);
